import { Grid } from "@mui/material"
import * as S from "../../components/menu-items/menu-items.styles"
import React from "react"
import parse from "html-react-parser"

const MenuItems = ({ index, image, name, price, description }) => {
  const parse = require("html-react-parser")

  return (
    <>
      <S.InnerColumns item xs={12} sm={4} key={`${name}-${index}`}>
        <S.Spacer container>
          {/*<Grid item xs={6} lg={4}>
        <a
          href={
            item.url === null
              ? "https://www.toasttab.com/halftime-pizza-boston-115-causeway-street"
              : item.url
          }
          target="_blank"
        >
          <div className="wrapper">
            <CustomImage
              img={item.image !== null ? item.image : image}
              style={item.image === null ? { border: "1px solid #000000" } : ""}
            />
          </div>
        </a>
      </Grid>*/}

          {/*        <a
          href={
            item.url === null
              ? "https://www.toasttab.com/halftime-pizza-boston-115-causeway-street"
              : item.url
          }
          target="_blank"
        >*/}
          <S.Wrapper>
            <S.Flex>
              {name && <h2>{name}</h2>}
              {price && <p>{price}</p>}
            </S.Flex>
            {description && <S.Description>{parse(description)}</S.Description>}
          </S.Wrapper>
          <S.Dash></S.Dash>
          {/*        </a>*/}
        </S.Spacer>
      </S.InnerColumns>
    </>
  )
}

export default MenuItems
